import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";
import Pagination from "@mui/material/Pagination";

import Layout from "../../../components/layout/Layout";
import { Grid, Box, TableCell, TableRow, TableBody, Typography, Paper, Select, MenuItem, createTheme } from "@mui/material";
import { Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect, useRef, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/usePaginationTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";
import { Image_API } from "../../../config";
import Admin from "../../../components/auth/Admin";
import Product from "../../../actions/product";
import AddProductForm from "../../../components/forms/addProduct";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import ImportFile from "../../../actions/ImportFile";
import { useHistory } from "react-router-dom";
import SaveFromFile from "../../../components/SaveFromFile";
import InfoComponent from "../../../components/InfoComponent";
import { pageSizes } from "../../../utils/utils";

const headCells = [
  { id: "name", label: "Name" },
  { id: "description", label: "Description" },
  { id: "sku", label: "Sku" },
  { id: "category", label: "Category" },
  { id: "type", label: "Type" },
  { id: "bar_code", label: "bar_code" },
  { id: "price", label: "Price" },
  { id: "quantitys", label: "Quantity" },
  { id: "actions", label: "Actions", disableSorting: true },
];
const theme = createTheme();
const useStyles = makeStyles(() => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const ProductPage = () => {
  const history = useHistory();
  const classes = useStyles();
  const [openPopupBulkSave, setOpenPopupBulkSave] = useState(false);
  const [record, setRecord] = useState({
    data: [],
    colDefs: [],
  });
  const [openPopupUpdate, setOpenPopupUpdate] = useState(false);
  const { data, colDefs, importExcel, setData } = ImportFile();
  const filePicker = useRef(null);
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllProductsWtihPages, deleteProduct } = Product();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [product, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(pageSizes[1]);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllProducts();
  }, [page, limit, searchQuery]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllProducts = () => {
    setValues({ ...values, loading: true });
    viewAllProductsWtihPages(page, limit, searchQuery).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.product) {
        setValues({
          ...values,
          loading: false,
        });
        setProducts(data.product);
        setTotalPages(Math.ceil(data.total / limit));
        setActualTotal(data.pagination.total);
        setTot(data.pagination.totalPages);
      }
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteProduct(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setProducts(
          produce(product, (draft) => {
            const index = product.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    console.log(value);
    setPage(1);
    setSearchQuery(value);
  };

  if (data && data.length != 0) {
    setRecord({ data, colDefs });
    setData([]);
    setOpenPopupBulkSave(true);
  }
  const handleDownload = () => {
    fetch(`${Image_API}/download`)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Network response was not ok.");
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "product.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) =>
        console.error("There was a problem with your fetch operation:", error)
      );
  };
  const totalQuantity = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return 0;
    }
    return data.reduce(
      (total, list) => total + parseInt(list.quantity || 0),
      0
    );
  };

  const price = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return 0;
    }

    return (
      data.reduce(
        (latest, item) =>
          new Date(item.updatedAt) > new Date(latest.updatedAt) ? item : latest,
        data[0]
      ).price || 0
    );
  };

  const { TblContainer, TblHead, recordsAfterSortingAndFiltering } = useTable(
    product,
    headCells,
    filterFn,
    {
      price: price,
      totalQuantity: totalQuantity,
    }
  );
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: { xs: "wrap", sm: "nowrap" },
              gap: { xs: 1, sm: 0 },
              "& > .newButton": {
                marginLeft: { xs: "auto", sm: "0" },
              },
              "@media (max-width: 455px)": {
                flexDirection: "column",
                alignItems: "flex-start",
              },
            }}
          >
            <Typography
              variant="h6"
              className="page-header"
              sx={{ whiteSpace: "nowrap" }}
            >
              Products
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: { xs: "wrap", sm: "nowrap" },
              }}
            >
              <Controls.Button
                text="Add Product"
                variant="outlined"
                startIcon={<IoMdAdd />}
                className="newButton"
                onClick={() => {
                  setOpenPopupUpdate(false);
                  setOpenPopup(true);
                  setRecordForEdit(null);
                  setEdit(false);
                }}
              />
              <Controls.Button
                color="primary"
                onClick={() => {
                  filePicker.current.click();
                }}
                startIcon={<UploadFileIcon />}
                variant="outlined"
                text="Import file"
                className="newButton"
              />
              <input
                label="Icon"
                name="image"
                type="file"
                hidden
                ref={filePicker}
                onChange={importExcel}
                autoFocus={true}
              />
              <Controls.Button
                color="primary"
                onClick={() => {
                  handleDownload();
                }}
                startIcon={<DownloadIcon />}
                variant="outlined"
                text="Download"
                className="newButton"
              />
            </Box>
          </Box>
          <InfoComponent pageKey="products" />

          <div
            className="search-header-container"
            style={{ marginBottom: 0, flex: 1, maxWidth: 260, minWidth: 260 }}
          >
            <div className="search-header-flex">
              <div className="search-container">
                <Search className="search_icon" />
                <input
                  type="text"
                  onChange={handleSearch}
                  placeholder="Search Product"
                  className="search-input"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{item.description}</TableCell>
                            <TableCell>{item.sku}</TableCell>
                            <TableCell>{item.category}</TableCell>
                            <TableCell>{item.type}</TableCell>
                            <TableCell>{item.bar_code}</TableCell>
                            <TableCell>{price(item.productLists)}</TableCell>
                            <TableCell>
                              {totalQuantity(item.productLists)}
                            </TableCell>
                            <TableCell>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  flexWrap: "nowrap",
                                }}
                              >
                                <Controls.ActionButton
                                  color="secondary"
                                  title="Delete"
                                  onClick={() => {
                                    setConfirmDialog({
                                      isOpen: true,
                                      title:
                                        "Are you sure to delete this Product?",
                                      subTitle: "You can't undo this operation",
                                      onConfirm: () => {
                                        onDelete(item.id);
                                      },
                                    });
                                  }}
                                >
                                  <MdOutlineDelete fontSize="medium" />
                                </Controls.ActionButton>
                                <Controls.ActionButton
                                  color="primary"
                                  title="Update"
                                  onClick={() => {
                                    setOpenPopup(true);
                                    setOpenPopupUpdate(true);
                                    setRecordForEdit(item);
                                    setEdit(true);
                                  }}
                                >
                                  <FiEdit fontSize="medium" />
                                </Controls.ActionButton>
                                {item.productLists.length > 0 && (
                                  <Controls.ActionButton
                                    color="primary"
                                    title="View Detail"
                                    onClick={() => {
                                      history.push(`/product/${item.id}`);
                                    }}
                                  >
                                    <FiEye fontSize="medium" />
                                  </Controls.ActionButton>
                                )}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {product.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || product.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={product.length === 0}
                      />
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Product Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddProductForm
            openPopupUpdate={openPopupUpdate}
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setProducts={setProducts}
            getAllProducts={getAllProducts}
            edite={edite}
          />
        </Popup>
        <Popup
          title="Import Product"
          openPopup={openPopupBulkSave}
          setOpenPopup={setOpenPopupBulkSave}
          maxWidth={false}
        >
          <SaveFromFile
            file={record}
            NotifyMessage={NotifyMessage}
            setOpenPopupBulkSave={setOpenPopupBulkSave}
            getAllProducts={getAllProducts}
            products={product}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default ProductPage;
